import(/* webpackMode: "eager", webpackExports: ["Anchor"] */ "/home/runner/work/web/web/node_modules/@mantine/core/esm/components/Anchor/Anchor.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["Stack"] */ "/home/runner/work/web/web/node_modules/@mantine/core/esm/components/Stack/Stack.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["Text"] */ "/home/runner/work/web/web/node_modules/@mantine/core/esm/components/Text/Text.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["Title"] */ "/home/runner/work/web/web/node_modules/@mantine/core/esm/components/Title/Title.mjs");
